
import { Layout as DashboardLayout } from 'src/layouts/dashboard/layout';
import { useEffect, useState } from "react";
import { PaymentTable } from "src/sections/riders/payment-table";
import {
    Box,
    Container,
    Stack,
    Unstable_Grid2 as Grid
} from '@mui/material';
import riderService from "src/services/riderService";

const Payment = () => {
    const [data, setData] = useState();
    const [page, setPage] = useState(0);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    useEffect(() => {
        fetchAllRiders();
    }, [page])

    const fetchAllRiders = async () => {
        await riderService.allRiders(page).then((res) => {
            if (res.status == 200) {
                setData(res.data.riders.data);
                setCurrentPage(res.data.riders.current_page);
                setTotalPages(res.data.riders.last_page);

            }
        })
    }
    const handlePageChange = newPage => {
      
         setPage(newPage);
       };
    return (
        <>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    py: 8
                }}
            >
                <PaymentTable
                    items={data}
                />
                <div className="mt-4 flex items-center justify-between">
                    <p className="text-gray-600">
                        Page {currentPage} of {totalPages}
                    </p>
                    <div className="flex space-x-2">
                        <button
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className={`px-4 py-2 rounded-md ${currentPage === 1 ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-blue-500 text-white hover:bg-blue-600'
                                }`}
                        >
                            Previous
                        </button>
                        <button
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className={`px-4 py-2 rounded-md ${currentPage === totalPages ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-blue-500 text-white hover:bg-blue-600'
                                }`}
                        >
                            Next
                        </button>
                    </div>
                </div>


            </Box>

        </>
    );
}



export default Payment;